import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-graphproof',
  templateUrl: './graphproof.component.html',
  styleUrls: ['./graphproof.component.css']
})
export class GraphproofComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
